import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { LoaderService } from '@services/loader.service';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  constructor(private loaderService: LoaderService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Skip loader for requests with 'skip-loader' header OR asset-management URLs
    if (req.headers.has('skip-loader') || req.url.includes('/asset-management/')) {
      const modifiedReq = req.headers.has('skip-loader')
        ? req.clone({ headers: req.headers.delete('skip-loader') })
        : req;
      return next.handle(modifiedReq);
    }

    this.loaderService.show();
    return next.handle(req).pipe(
      tap(
        (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse || event instanceof HttpErrorResponse) {
            this.loaderService.hide();
          }
        },
        (error: any) => {
          this.loaderService.hide();
        }
      )
    );
  }
}
